import { Language } from '../types';

export const LANGUAGES: Language[] = [
  { code: 'auto', name: 'Auto Detect', nativeName: '自动检测' },
  { code: 'am', name: 'Amharic', nativeName: 'አማርኛ' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
  { code: 'bg', name: 'Bulgarian', nativeName: 'български' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা' },
  { code: 'bs', name: 'Bosnian', nativeName: 'bosanski' },
  { code: 'ca', name: 'Catalan', nativeName: 'català' },
  { code: 'cs', name: 'Czech', nativeName: 'čeština' },
  { code: 'da', name: 'Danish', nativeName: 'dansk' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'el', name: 'Greek', nativeName: 'Ελληνικά' },
  { code: 'en-US', name: 'English (US)', nativeName: 'English (United States)' },
  { code: 'es-419', name: 'Spanish (Latin America)', nativeName: 'español (Latinoamérica)' },
  { code: 'es-ES', name: 'Spanish (Spain)', nativeName: 'español (España)' },
  { code: 'et', name: 'Estonian', nativeName: 'eesti' },
  { code: 'fi', name: 'Finnish', nativeName: 'suomi' },
  { code: 'fr-CA', name: 'French (Canada)', nativeName: 'français (Canada)' },
  { code: 'fr-FR', name: 'French (France)', nativeName: 'français (France)' },
  { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'hr', name: 'Croatian', nativeName: 'hrvatski' },
  { code: 'hu', name: 'Hungarian', nativeName: 'magyar' },
  { code: 'hy', name: 'Armenian', nativeName: 'Հայերեն' },
  { code: 'id', name: 'Indonesian', nativeName: 'Indonesia' },
  { code: 'is', name: 'Icelandic', nativeName: 'íslenska' },
  { code: 'it', name: 'Italian', nativeName: 'italiano' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  { code: 'ka', name: 'Georgian', nativeName: 'ქართული' },
  { code: 'kk', name: 'Kazakh', nativeName: 'қазақ тілі' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  { code: 'ko', name: 'Korean', nativeName: '한국어' },
  { code: 'lt', name: 'Lithuanian', nativeName: 'lietuvių' },
  { code: 'lv', name: 'Latvian', nativeName: 'latviešu' },
  { code: 'mk', name: 'Macedonian', nativeName: 'македонски' },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം' },
  { code: 'mn', name: 'Mongolian', nativeName: 'монгол' },
  { code: 'mr', name: 'Marathi', nativeName: 'मराठी' },
  { code: 'ms', name: 'Malay', nativeName: 'Bahasa Melayu' },
  { code: 'my', name: 'Myanmar', nativeName: 'မြန်မာ' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', nativeName: 'português (Brasil)' },
  { code: 'pt-PT', name: 'Portuguese (Portugal)', nativeName: 'português (Portugal)' },
  { code: 'ro', name: 'Romanian', nativeName: 'română' },
  { code: 'ru', name: 'Russian', nativeName: 'русский' },
  { code: 'sk', name: 'Slovak', nativeName: 'slovenčina' },
  { code: 'sl', name: 'Slovenian', nativeName: 'slovenščina' },
  { code: 'so', name: 'Somali', nativeName: 'Soomaali' },
  { code: 'sq', name: 'Albanian', nativeName: 'shqip' },
  { code: 'sr', name: 'Serbian', nativeName: 'српски' },
  { code: 'sv', name: 'Swedish', nativeName: 'svenska' },
  { code: 'sw', name: 'Swahili', nativeName: 'Kiswahili' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย' },
  { code: 'tl', name: 'Tagalog', nativeName: 'Tagalog' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe' },
  { code: 'uk', name: 'Ukrainian', nativeName: 'українська' },
  { code: 'ur', name: 'Urdu', nativeName: 'اردو' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt' },
  { code: 'zh-HK', name: 'Traditional Chinese (Hong Kong)', nativeName: '繁體中文（香港）' },
  { code: 'zh-TW', name: 'Traditional Chinese (Taiwan)', nativeName: '繁體中文（台灣）' },
  { code: 'zh-CN', name: 'Simplified Chinese (China)', nativeName: '简体中文（中国大陆）' },
  { code: 'fa', name: 'Persian', nativeName: 'فارسی' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands' },
  { code: 'he', name: 'Hebrew', nativeName: 'עברית' },
  { code: 'no', name: 'Norwegian', nativeName: 'Norsk' },
  { code: 'uz', name: 'Uzbek', nativeName: 'O\'zbekcha' },
  { code: 'az', name: 'Azerbaijani', nativeName: 'Azərbaycan dili' },
  { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ' },
  { code: 'ha', name: 'Hausa', nativeName: 'Hausa' },
  { code: 'yo', name: 'Yoruba', nativeName: 'Yorùbá' },
  { code: 'ig', name: 'Igbo', nativeName: 'Igbo' },
  { code: 'si', name: 'Sinhala', nativeName: 'සිංහල' },
  { code: 'ne', name: 'Nepali', nativeName: 'नेपाली' },
  { code: 'km', name: 'Khmer', nativeName: 'ភាសាខ្មែរ' },
  { code: 'lo', name: 'Lao', nativeName: 'ພາສາລາວ' },
  { code: 'zu', name: 'Zulu', nativeName: 'isiZulu' },
  { code: 'mg', name: 'Malagasy', nativeName: 'Malagasy' },
  { code: 'st', name: 'Sesotho', nativeName: 'Sesotho' },
  { code: 'tn', name: 'Setswana', nativeName: 'Setswana' },
  { code: 'ln', name: 'Lingala', nativeName: 'Lingala' },
  { code: 'rw', name: 'Kinyarwanda', nativeName: 'Kinyarwanda' },
  { code: 'ti', name: 'Tigrinya', nativeName: 'ትግርኛ' },
  { code: 'tk', name: 'Turkmen', nativeName: 'Türkmen dili' },
  { code: 'tg', name: 'Tajik', nativeName: 'тоҷикӣ' },
  { code: 'ku', name: 'Kurdish', nativeName: 'Kurdî' },
  { code: 'ps', name: 'Pashto', nativeName: 'پښتو' },
  { code: 'jv', name: 'Javanese', nativeName: 'Basa Jawa' },
  { code: 'sd', name: 'Sindhi', nativeName: 'سنڌي' },
  { code: 'mt', name: 'Maltese', nativeName: 'Malti' },
];

// 检测系统语言
export const detectSystemLanguage = (): string => {
  const browserLang = navigator.language || navigator.languages?.[0] || 'en-US';

  // 尝试精确匹配
  const exactMatch = LANGUAGES.find(lang => lang.code === browserLang);
  if (exactMatch) {
    return browserLang;
  }

  // 尝试语言代码匹配 (例如: en-US -> en)
  const langCode = browserLang.split('-')[0];
  const langMatch = LANGUAGES.find(lang => lang.code.startsWith(langCode));
  if (langMatch) {
    return langMatch.code;
  }

  // 默认返回英语
  return 'en-US';
};

// 获取语言显示名称
export const getLanguageDisplayName = (code: string): string => {
  const language = LANGUAGES.find(lang => lang.code === code);
  return language ? `${language.nativeName} (${language.name})` : code;
}; 